const CreditType = {
    LOAN: "loan",
    REVOLVING_CREDIT: "revolving_credit",
}

export default CreditType
